import { useEffect, useRef, useState } from "react";
import { getImage } from "../Functions/getCropedImage";
import {
  uploadLogo,
  uploadWaterMarkLogo,
} from "../../store/slices/GetStarted/getStartedSlice";
import { useDispatch, useSelector } from "react-redux";
import { updateHeaderState } from "../../store/slices/GetStarted/userBasicDataSlice";
import { ToastContainer, toast } from "react-toastify";
import { centerCrop, makeAspectCrop } from "react-image-crop";

export const useCrop = ({ stepsData, setStepsData, type, close, open }) => {
  const { userProfileData } = useSelector((state) => state.userData);
  const dispatch = useDispatch();
  const imgRef = useRef(null);
  const tempRef = useRef(null);
  const [selectedImage, setSelectedImage] = useState(null);
  const [tempImage, setTempImage] = useState(null);

  const [openCrop, setOpenCrop] = useState(false);
  const [crop, setCrop] = useState({
    aspect: null,
    width: 50,
    height: 50,
    unit: "px",
    x: 50,
    y: 50,
  });
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [opacity, setOpacity] = useState(100);
  useEffect(() => {
    if (userProfileData?.logo_url && type == "logo") {
      setSelectedImage(userProfileData?.logo_url);
      setTempImage(userProfileData?.logo_url);
    }
    //  else if (userProfileData?.water_mark_url && type == 'waterMark') {
    //     setSelectedImage(userProfileData?.water_mark_url)
    //     setTempImage(userProfileData?.water_mark_url)
    // }
    if (!open) {
      setSelectedImage("");
      setTempImage("");
    }
  }, [type, open]);

  const RemoveImage = () => {
    setSelectedImage(null);
  };

  const handleDragOver = (e) => {
    e.stopPropagation();
    e.preventDefault();
  };

  const handleDragOut = (e) => {
    e.stopPropagation();
    e.preventDefault();
  };

  const handleDrop = (e) => {
    e.stopPropagation();
    e.preventDefault();
    if (e.dataTransfer.files.length > 0) {
      let fileSize = e.dataTransfer.files[0].size / 1024 / 1024;
      if (fileSize > 2) {
        setError(
          "This file is too large to upload. maximum supported file size is 2MB"
        );
        setTimeout(() => {
          setError("");
        }, 4000);
      } else {
        setSelectedImage(URL.createObjectURL(e.dataTransfer.files[0]));
        setTempImage(URL.createObjectURL(e.dataTransfer.files[0]));
      }
    }
  };

  const handleImageChange = (e) => {
    if (e.target.files.length > 0) {
      const allowedExtensions = ["jpeg", "jpg", "png"];
      const file = e.target.files[0];
      const fileExtension = file.name.split(".").pop().toLowerCase();
      let fileSize = e.target.files[0].size / 1024 / 1024;
      if (fileSize > 2) {
        setError(
          "This file is too large to upload. maximum supported file size is 2MB"
        );
        setTimeout(() => {
          setError("");
        }, 4000);
      } else {
        if (allowedExtensions?.includes(fileExtension)) {
          setSelectedImage(URL.createObjectURL(e.target.files[0]));
          setTempImage(URL.createObjectURL(e.target.files[0]));
          setTimeout(() => {
            setError("");
          }, 4000);
        } else {
          setError("The file must be a .jpeg, .jpg, or .png file.");
          setTimeout(() => {
            setError("");
          }, 4000);
        }
      }
    }
  };

  const handleChangeOpacity = async (e) => {
    setOpacity(e);
    let { getUrl } = await getImage(
      tempRef.current,
      { aspect: 1 / 1 },
      "logo",
      0.01 * e
    );
    setSelectedImage(getUrl());
  };

  const handleSave = async () => {
    setIsLoading(true);
    if (type == "logo") {
      let { getImageFile } = await getImage(
        imgRef.current,
        crop,
        opacity,
        "logo"
      );
      let newFile = await getImageFile().then((res) => res);
      let formData = new FormData();
      formData.append("image", newFile);

      let resultAction = await dispatch(uploadLogo(formData));
      if (uploadLogo.fulfilled.match(resultAction)) {
        dispatch(
          updateHeaderState(resultAction?.payload?.data?.result?.logo_url)
        );
        let newdata = [...stepsData];
        newdata[0].img = resultAction?.payload?.data?.result?.logo_url;
        toast.success("Logo Added successfully", {
          position: "bottom-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        setStepsData(newdata);
        setIsLoading(false);
        setCrop({ aspect: 1 / 1 });
        close();
      }
    }

    // else {
    //     let { getImageFile } = await getImage(imgRef.current, crop, "logo");
    //     let newFile = await getImageFile().then(res => res)

    //     let formData = new FormData();
    //     formData.append("image", newFile);

    //     let resultAction = await dispatch(uploadWaterMarkLogo(formData))
    //     if (uploadWaterMarkLogo.fulfilled.match(resultAction)) {

    //         let newdata = [...stepsData];
    //         newdata[1].img = resultAction?.payload?.data?.result?.water_mark_url;
    //         setStepsData(newdata)
    //         setIsLoading(false)
    //         setCrop({ aspect: 16 / 9 })
    //         close()

    //         if (resultAction?.payload?.data?.validation) {
    //             setError(resultAction?.payload?.data?.validation?.errors?.image?.[1])
    //             setTimeout(() => {
    //                 setError("");
    //             }, 2000);
    //         }
    //     }
    // }
  };
  const onLoadImage = (e) => {
    const { width, height } = e.currentTarget;
    const aspect = 1 / 1;

    const crop = centerCrop(
      makeAspectCrop(
        {
          unit: "px",
          width: 50,
        },
        aspect,
        width,
        height
      ),
      width,
      height
    );

    setCrop(crop);
  };

  const handleCancelCrop = () => {
    setIsLoading(false);
    setCrop({ aspect: 1 / 1 });
    close();
  };

  // imgRef

  return {
    imgData: userProfileData,
    imgRef,
    tempRef,
    crop,
    tempImage,
    selectedImage,
    error,
    openCrop,
    isLoading,
    setCrop,
    setSelectedImage,
    handleDragOver,
    handleDragOut,
    handleDrop,
    handleImageChange,
    handleSave,
    RemoveImage,
    handleChangeOpacity,
    handleCancelCrop,
    onLoadImage,
  };
};
